// Code generated by scripts/gen-sdk-permissions from internal/firestore.Permissions; DO NOT EDIT.
// Run `task permissions:sync` to regenerate. CI gates this file (git diff --exit-code).
//
// The lowercase permission wire enum carried in the user JWT's `perm` claim
// and returned by auth.me()/auth.users(). A value outside this set decodes to
// "" in the SDK, so keeping it in step with the Go enum is load-bearing.

export type Permission = "admin" | "user" | "viewer";

export const PERMISSIONS: ReadonlySet<Permission> = new Set([
  "admin",
  "user",
  "viewer",
]);
